export default __webpack_public_path__ + "static/media/delete.b6825a0c.svg";